export function string_trim(str) {
    const res = str !== null ? str : str.replace(/^\s+|\s+$/g, '');
    return res;
}

export abstract class CoreConstants {
    static ACCOUNT: string = 'account';
    static ADVISOR: string = 'advisor';
    static ACCOUNT_MIN_LENGTH: number = 9;
    static GROUP: string = 'group';
    static HOUSEHOLD: string = 'household';
    static CLIENT: string = 'client';
    static IBD: string = 'ibd';
    static OFF: string = 'off';
    static IP: string = 'ip';
    static IWE_GROUPNAME: string = 'iwm';
    static GROUP_MIN_LENGTH: number = 1;
    static SECURITY: string = 'security';
    static IBDOFFIP: string = 'ibdoffip';
    static DEVICETYPE: string = 'desktop';
    static DEFAULT_PAGEID: string = 'my-practice';
    static MENU_MAX_LENGTH: number = 15;

    static SYSTEM_ERROR_MESSAGE: string = 'The system is unable to process your request at this time. Please try again later.';
}
